/**
 *
 * @author Juan Rico
 * @component NSBoolean
 * @description un boton tipo boolean  personalizable
 * normalmente usado para funciones boleanas con callback
 */

//#region  Importaciones necesarias para el componente NSBoolean
import React, { useEffect, useState } from "react"; // Importa React y hooks.
import { PlatformMobile, PRIMARY_COLOR } from "../../../helpers/Constants"; //importar constantes
import { isMobile, isDesktop, isIPad13, isTablet } from "react-device-detect"; // importacion de elementos responsive
import useTranslation from "../../../hooks/useTranslation";
import { Ic_check_M } from "../../../helpers/ImagesCache";
//#endregion

/**
 * Componente tipo boton booleano.
 *
 * @function NSBoolean
 * @returns {JSX.Element} Un elemento que representa la interfaz de simulacion basica.
 * @argument {String} title - Titulo del componente
 * @argument {JSX.Element}  icon - Icono del componente
 * @argument {Boolean}  initialState - Estado inicial del componente
 * @argument {Function}  onClick - Accion callback al presionar CLICK
 * @argument {Boolean}  forceDisable - Forzar la desactivacion la accion de este componente
 * @argument {Boolean}  forceStop - Forzar DETENER el temporizador de este componente
 * @argument {Boolean}  noChecker - Ocultar el checkbox (la accion sigue manteniendose)
 */
const NSBoolean = ({
  title, //Titulo del componente
  icon, //Icono del componente
  initialState, //Estado inicial del componente
  onClick, //Accion callback al presionar CLICK
  forceEnable, //Forzar ACTIVAR este componente
  forceDisable, //Forzar la desactivacion la accion de este componente
  forceStop, //Forzar DETENER el temporizador de este componente
  noChecker, //ocultar el checkbox (la accion sigue manteniendose),
  minimal,
}) => {
  const T = useTranslation();
  //#region ############## VARIABLES DE ESTADO GENERALES ##############/
  /**
   * Estado del componente
   * @type {Boolean}
   * @default initialState - controlar el cambio de estado del componente
   */
  const [status, setStatus] = useState(initialState);
  //#endregion

  //#region ############## FUNCIONES HANDLE BASICAS ##############
  /**
   * Manejador del estado status para iniciarlo y tener un callback
   * @function handleStatus
   * Se utiliza para cambiar el estado y accionar el callback onClick
   * en caso de que se pase la prop correspondiente
   */
  const handleStatus = () => {
    if (forceStop) return;
    if (forceDisable) return;
    setStatus(!status);
    if (onClick) {
      onClick(!status);
    }
  };
  //#endregion

  // Hook que se ejecuta al montar el componente
  // registramos los ticks cada vez que diff o start cambian.
  useEffect(() => {
    if (forceEnable) {
      setStatus(false);
    }
  }, [forceEnable]);

  return (
    <>
      <div
        onClick={forceDisable ? undefined : handleStatus}
        style={{
          opacity: forceDisable ? "50%" : "100%",
          background: forceDisable ? "#F5FBFA" : "#fff",
          justifyContent: "space-between",
        }}
        className={`p-[10px] bg-white rounded-[16px] flex flex-1 flex-col items-center ${
          forceDisable ? "" : " cursor-pointer shadow shadow-[#2AAC9C4D]"
        }  `}
      >
        <div className="flex p-1 items-start gap-2 justify-between w-full">
          <div
            className="text-black select-none flex flex-col p-1 justify-center w-4/6 font-[700] leading-tight line-clamp-2"
            style={{
              fontSize: isTablet
                ? "clamp(12px, 2vw, 18px)"
                : "clamp(10px, 4vw, 12px)",
            }}
          >
            {T(title)}
          </div>

          <div
            className="flex select-none items-center justify-center w-2-6 rounded rounded-[8px] p-[4px]"
            style={{
              backgroundColor: forceDisable ? "transparent" : "#FEEFF2",
              height: isTablet ? "48px" : "36px",
              aspectRatio: 1,
            }}
          >
            <img src={icon} alt={icon} />
          </div>
        </div>
        <div className="flex p-1 items-center justify-between gap-2 w-full">
          <div className="flex p-1 items-center w-4/6">
            {!noChecker &&
              (status ? (
                <img src={Ic_check_M} className="-m-2" />
              ) : (
                <div className=" h-[24px] w-[24px] rounded-[4px] border-[2px] border-solid border-[#BDBBBC]" />
              ))}
          </div>
        </div>
      </div>
    </>
  );
};

export default NSBoolean;
